import React, {lazy, Suspense} from 'react';

import Wrapper from "./Wrapper";
import { useFormContext } from './Provider';
import Actions from "./Actions";
import Conditional from "./Conditional";
// Files
import AllowedTimes from "./Fields/AllowedTimes";
import Checkboxes from "./Fields/Checkboxes";
import DateTime from "./Fields/DateTime";
import Duration from "./Fields/Duration";
import EventTriggers from "./Fields/EventTriggers";
import Frequency from "./Fields/Frequency";
import Hidden from "./Fields/Hidden";
import ItemisationAdjustment from "./Fields/ItemisationAdjustment";
import Money from "./Fields/Money";
import OptionalTime from "./Fields/OptionalTime";
import Password from "./Fields/Password";
import Repeatable from "./Fields/Repeatable";
import Round from "./Fields/Round";
import Section from "./Fields/Section";
import Select from "./Fields/Select";
import Services from "./Fields/Services";
import Settings from "./Fields/Settings";
import Switch from "./Fields/Switch";
import SwitchGroup from "./Fields/SwitchGroup";
import Tags from "./Fields/Tags";
import TagColour from "./Fields/TagColour";
import TagIcon from "./Fields/TagIcon";
import TextArea from "./Fields/TextArea";
import TextField from "./Fields/TextField";
import TimeRange from "./Fields/TimeRange";
import ULID from "./Fields/ULID";
import User from "./Fields/User";
import Week from "./Fields/Week";
import Wysiwyg from "./Fields/Wysiwyg";

// Validators
import AddressValidator from "./Validators/Address";
import CustomValidator from "./Validators/Custom";
import EmailAddressValidator from "./Validators/EmailAddress";
import ItemisationAdjustmentValidator from "./Validators/ItemisationAdjustment";
import NumberValidator from "./Validators/Number";
import MoneyValidator from "./Validators/Money";
import OptionalTimeValidator from "./Validators/OptionalTime";
import PasswordValidator from "./Validators/Password";
import PhoneNumberValidator from "./Validators/PhoneNumber";
import RegexValidator from "./Validators/Regex";
import RequiredValidator from "./Validators/Required";
import URLValidator from "./Validators/URL";
import { ulid } from "ulid";

const AssetsLazy = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */"./Fields/Assets"));
const PhoneNumberLazy = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */"./Fields/PhoneNumber"));
const RadioLazy = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */"./Fields/Radio"));
const AddressLazy = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */"./Fields/Address"));
const WorkingHoursLazy = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */"./Fields/WorkingHours"));
const ScheduleConstraintsLazy = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */"./Fields/ScheduleConstraints"));

const Form = Wrapper;
export default Form;

const parseSettingsToData = (settings, filter) => {
    if (settings === null) {
        return null;
    }

    return settings.reduce((data, setting) => {
        if (filter && filter.includes(setting.key) === false) {
            return data;
        }

        if (setting.key === 'Quotes:FrequencyChoices') {
            data[setting.key] = setting.value.map(option => ({
                frequency: option,
                _id: ulid(),
            }));
            return data;
        }

        data[setting.key] = setting.html ?? setting.value;
        return data;
    }, {});
}

const Assets = (props) => <Suspense><AssetsLazy {...props} /></Suspense>
const PhoneNumber = (props) => <Suspense><PhoneNumberLazy {...props} /></Suspense>
const Radio = (props) => <Suspense><RadioLazy {...props} /></Suspense>
const Address = (props) => <Suspense><AddressLazy {...props} /></Suspense>
const WorkingHours = (props) => <Suspense><WorkingHoursLazy {...props} /></Suspense>
const ScheduleConstraints = (props) => <Suspense><ScheduleConstraintsLazy {...props} /></Suspense>

export {
    Form,
    useFormContext,
    Actions,
    Conditional,
    parseSettingsToData,
    // Files
    Address,
    AllowedTimes,
    Assets,
    Checkboxes,
    DateTime,
    Duration,
    EventTriggers,
    Frequency,
    Hidden,
    ItemisationAdjustment,
    Money,
    OptionalTime,
    Password,
    PhoneNumber,
    Radio,
    Repeatable,
    Round,
    Section,
    Select,
    Services,
    Settings,
    Switch,
    SwitchGroup,
    Tags,
    TagColour,
    TagIcon,
    TextArea,
    TextField,
    TimeRange,
    ULID,
    User,
    Week,
    WorkingHours,
    Wysiwyg,
    // Validators
    AddressValidator,
    CustomValidator,
    EmailAddressValidator,
    ItemisationAdjustmentValidator,
    NumberValidator,
    MoneyValidator,
    OptionalTimeValidator,
    PasswordValidator,
    PhoneNumberValidator,
    RegexValidator,
    RequiredValidator,
    ScheduleConstraints,
    URLValidator,
}
